import { parseAgrEnvironment } from '@next/core-lib/environment';

import { Environment } from '../../../environments/environment.model';

/**
 * Parse environment variables including custom Field Advice specific variables
 */
export const parseOrderplanningEnvironment = (config: Record<string, string>): Environment => {
  // Parse base AGR environment variables
  const baseEnvironment = parseAgrEnvironment(config);

  // Parse custom Field Advice specific variables
  return {
    ...baseEnvironment,
    FIELD_ADVICE_URL: config.FIELD_ADVICE_URL || '',
    FIELD_PLAN_URL: config.FIELD_PLAN_URL || '',
    ENABLE_SEND_ORDER: config.ENABLE_SEND_ORDER === 'true',
    CART_ENABLED: config.CART_ENABLED === 'true',
    USE_PRODUCT_V2_ID: config.USE_PRODUCT_V2_ID === 'true',
    AZURE_MAPS_SATELLITE_SUBSCRIPTION_KEY: config.AZURE_MAPS_SATELLITE_SUBSCRIPTION_KEY || '',
    AZURE_MAPS_SUBSCRIPTION_KEY: config.AZURE_MAPS_SUBSCRIPTION_KEY || '',
    PRE_SALES_REBUILD_DONE: config.PRE_SALES_REBUILD_DONE === 'true',
    FIELD_ADVICE_REBUILD_DONE: config.FIELD_ADVICE_REBUILD_DONE === 'true',
  };
};
